import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { clearState, registerUser } from "../../redux/Slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

const Register = () => {
  const { t, i18n } = useTranslation("global");
  const [tab, setTab] = useState("individual");
  const navigate = useNavigate();
  const { isLoading, error, new_user, validationErrors } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: "",
    // age: "",
    email: "",
    phone: "",
    // national_id: "",
    password: "",
    password_confirmation: "",
    // bio: "",
    company_type: null,
    username: "",
    individual_type: null,
  });

  // dynamic job title and company type
  // useEffect(() => {
  //   const lang = i18n.language;

  //   fetch("https://app.xn--mgb9a0bp.com/api/job-titles", {
  //     headers: {
  //       Lang: lang,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setJobTitles(
  //         data.data.map((item) => ({
  //           value: item.id,
  //           label: item.name,
  //         }))
  //       );
  //     });

  //   fetch("https://app.xn--mgb9a0bp.com/api/company-types", {
  //     headers: {
  //       Lang: lang,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setCompanyTypes(
  //         data.data.map((item) => ({
  //           value: item.id,
  //           label: item.name,
  //         }))
  //       );
  //     });
  // }, [i18n.language]);

  const individualTypes = ["client", "marketer", "engineer", "instructor"];
  const companyTypes = ["real_estate", "engineering", "educational", "tech"];
  
  const individualTypeOptions = individualTypes.map((type) => ({
    value: type,
    label: t(`jobTitles.${type}`),
  }));

  const companyTypeOptions = companyTypes.map((type) => ({
    value: type,
    label: t(`companyTypes.${type}`),
  }));
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (name, selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      [name]: selectedOption?.value || "",
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.phone.length < 11 || formData.phone.length > 11) {
      toast.error(t("validation.the_phone_field_must_be_at_least_11_characters"))
      return;
    }
    if (formData.password.length !== formData.password_confirmation.length) {
      toast.error(t("validation.the_password_field_confirmation_does_not_match"))
      return;
    }

    const payload = {
      type: tab,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      // national_id: formData.national_id,
      password: formData.password,
      password_confirmation: formData.password_confirmation,
      // bio: formData.bio,
      ...(tab === "individual"
        ? {
          // age: formData.age,
          individual_type: formData.individual_type,
        }
        : {
          username: formData.username,
          company_type: formData.company_type,
        }),
    };
    dispatch(registerUser(payload));
  };

  useEffect(() => {
    if (new_user) {
      sessionStorage.setItem("new_user_3ayin", JSON.stringify(new_user));
      toast.success(t("sign.registrationSuccessful"));
      navigate("/verify_email", { replace: true });
    }
  }, [new_user, t, navigate]);

  useEffect(() => {
    if (!validationErrors) return;

    const errorMap = {
      email: "validation.the_email_has_already_been_taken",
      username: "validation.the_username_has_already_been_taken",
      // age: "validation.the_age_field_must_be_at_least_16",
      phone: "validation.the_phone_has_already_been_taken",
      name: "validation.the_name_field_is_required",
      // bio: "validation.the_bio_field_must_be_at_least_10_characters",
      password: "validation.the_password_field_must_be_at_least_6_characters",
      password_confirmation:
        "validation.the_password_field_confirmation_does_not_match",
    };

    // handle national_id separately
    // if (validationErrors.national_id) {
    //   validationErrors.national_id.forEach((msg) => {
    //     if (msg.toLowerCase().includes("already been taken")) {
    //       toast.error(t("validation.the_national_id_has_already_been_taken"));
    //     } 
    //     else if (msg.toLowerCase().includes("must be at least")) {
    //       toast.error(
    //         t("validation.the_national_id_field_must_be_at_least_14_characters")
    //       );
    //     } 
    //     else if (msg.toLowerCase().includes("must not be greater than 14 characters")) {
    //       toast.error(
    //         t("validation.the_national_id_field_must_not_be_greater_than_14_characters")
    //       );
    //     } 
    //     else {
    //       // fallback if backend sends another message
    //       toast.error(msg);
    //     }
    //   });
    // }

    Object.entries(errorMap).forEach(([field, translationKey]) => {
      if (validationErrors[field]) {
        validationErrors[field].forEach(() => toast.error(t(translationKey)));
      }
    });
    dispatch(clearState());
  }, [validationErrors, t, i18n.language]);

  return (
    <div
      className="registration_forms h-auto py-4"
      style={{ backgroundImage: "url('/register-bg.jpg')" }}
    >
      <div className="register_div">
        <div className="container">
          <Link to="/">
            <img className="logo mb-4" src="/logo-white.png" alt="logo" />
          </Link>

          {/* Segmented Tabs */}
          <div className="flight-types">
            <input
              type="radio"
              id="individual"
              name="register-tab"
              checked={tab === "individual"}
              onChange={() => setTab("individual")}
              className="hidden"
            />
            <label htmlFor="individual">{t("sign.individual")}</label>

            <input
              type="radio"
              id="company"
              name="register-tab"
              checked={tab === "company"}
              onChange={() => setTab("company")}
              className="hidden"
            />
            <label htmlFor="company">{t("sign.company")}</label>

            <div className="slider"></div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row">
              {tab === "individual" ? (
                <>
                  <div className="col-md-6">
                    <label className="text-dark">{t("profile.name")}</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder={t("profile.name")}
                      required
                    />
                  </div>
                  {/* <div className="col-md-6">
                    <label className="text-dark">{t("profile.age")}</label>
                    <input
                      type="number"
                      name="age"
                      min="0"
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      value={formData.age}
                      onChange={handleChange}
                      required
                      placeholder={t(
                        "validation.the_age_field_must_be_at_least_16"
                      )}
                    />
                  </div> */}
                </>
              ) : (
                <>
                  <div className="col-md-6">
                    <label className="text-dark">
                      {t("sign.company_name")}
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder={t("sign.company_name")}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="text-dark">
                      {t("sign.account_username")}
                    </label>
                    <input
                      type="text"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      placeholder={t("sign.account_username")}
                    />
                  </div>
                </>
              )}

              <div className="col-md-6">
                <label className="text-dark">{t("profile.email")}</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="example@gmail.com"
                />
              </div>

              <div className="col-md-6">
                <label className="text-dark">{t("profile.phone")}</label>
                <input
                  type="number"
                  name="phone"
                  inputMode="numeric"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder={t(
                    "validation.the_phone_field_must_be_at_least_11_characters"
                  )}
                />
              </div>

              {tab === "individual" ? (
                <div className="col-md-6">
                  <label className="text-dark">{t("profile.jobTitle")}</label>
                  <Select
                    name="individual_type"
                    value={individualTypeOptions.find((opt) => opt.value === formData.individual_type) || null}
                    onChange={(option) => handleSelectChange("individual_type", option)}
                    classNamePrefix="react-select"
                    options={individualTypeOptions}
                    placeholder={t("profile.jobTitle")}
                    required
                  />
                </div>
              ) : (
                <div className="col-md-6">
                  <label className="text-dark">{t("sign.company_type")}</label>
                  <Select
                    name="company_type"
                    value={companyTypeOptions.find((opt) => opt.value === formData.company_type) || null}
                    onChange={(option) => handleSelectChange("company_type", option)}
                    classNamePrefix="react-select"
                    options={companyTypeOptions}
                    placeholder={t("sign.company_type")}
                    required
                  />
                </div>
              )}

              {/* <div className="col-md-6">
                <label className="text-dark">{t("profile.nationalId")}</label>
                <input
                  type="number"
                  min="0"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                  name="national_id"
                  value={formData.national_id}
                  onChange={handleChange}
                  required
                  placeholder={t(
                    "validation.the_national_id_field_must_be_at_least_14_characters"
                  )}
                />
              </div> */}

              <div className="col-md-6">
                <label className="text-dark">{t("sign.password")}</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  autoComplete="off"
                  required
                  placeholder={t("sign.password")}
                />
              </div>

              <div className="col-md-6">
                <label className="text-dark">{t("sign.confirmPassword")}</label>
                <input
                  type="password"
                  name="password_confirmation"
                  value={formData.password_confirmation}
                  onChange={handleChange}
                  autoComplete="off"
                  required
                  placeholder={t("sign.confirmPassword")}
                />
              </div>

              {/* <div className="col-12">
                <label className="text-dark">{t("profile.bio")}</label>
                <textarea
                  name="bio"
                  value={formData.bio}
                  onChange={handleChange}
                  required
                  placeholder={t(
                    "validation.the_bio_field_must_be_at_least_10_characters"
                  )}
                ></textarea>
              </div> */}
            </div>

            <div className="text-center">
              <button type="submit" disabled={isLoading}>
                {isLoading ? t("sign.loading") : t("sign.register")}
              </button>
            </div>
            <div className="text-sm text-center my-3">
              <span className="text-dark">{t("sign.haveAccount")}</span>
              <span className="fw-bold mx-1">
                <a className="main-color" href="/login">
                  {t("sign.login")}
                </a>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;